export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/next-arrow.39d15351.svg","height":31,"width":32,"blurWidth":0,"blurHeight":0};